import { Box } from '@mui/material';
import { Theme, styled } from '@mui/material/styles';

export const StyledBoxStyle = styled(Box)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: '8px',
  padding: '5px 0 17px 0',
  cursor: 'pointer',
  '&:hover': { backgroundColor: theme.palette.action.hover },
}));
